import { isPresent, isType } from '@mtna/core-ts';
import { RelationalOperator } from '@mtna/data-core-ts';
import { Moment } from 'moment';

export const rdsDateOperations = ['GT', 'GE', 'EQ', 'NE', 'LT', 'LE'] as const;
export type RdsDateOperation = Extract<RelationalOperator, 'GT' | 'GE' | 'EQ' | 'NE' | 'LT' | 'LE'>;

export const rdsDateOperationLabels: Record<RdsDateOperation, string> = {
  GT: $localize`Greater than`,
  GE: $localize`Greater than or Equal to`,
  EQ: $localize`Equal to`,
  NE: $localize`Not Equal to`,
  LT: $localize`Less than`,
  LE: $localize`Less than or Equal to`,
} as const;

export function invertDateOperation(operation: RdsDateOperation): RdsDateOperation {
  switch (operation) {
    case 'GT':
      return 'LT';
    case 'GE':
      return 'LE';
    case 'EQ':
      return 'NE';
    case 'NE':
      return 'EQ';
    case 'LT':
      return 'GT';
    case 'LE':
      return 'GE';
  }
}

export class RdsDateOperationOption {
  constructor(public label: string, public type: RdsDateOperation) {}
}

export const RDS_DATE_OPERATION_OPTIONS: ReadonlyArray<RdsDateOperationOption> = Object.freeze(
  rdsDateOperations.map((operation) => new RdsDateOperationOption(rdsDateOperationLabels[operation], operation))
);

export class RdsDateFilter {
  constructor(public value: Moment | null, public operation: RdsDateOperationOption | null) {}
}

/** @returns A date string formatted as YYYY-MM-DD given a `RdsDateFilter` */
export function getRdsDateFilterIso(filter: RdsDateFilter): string {
  return getRdsMomentIso(filter?.value);
}

/** @returns A date string formatted as YYYY-MM-DD given a moment date */
export function getRdsMomentIso(date: Moment | null): string {
  return !date ? '' : date.format('YYYY-MM-DD');
}

export function instanceOfRdsDateFilter(something: unknown): something is RdsDateFilter {
  return (
    isType<RdsDateFilter>(something, 'value', 'operation') &&
    isPresent(something.operation) &&
    rdsDateOperations.includes(something.operation.type)
  );
}
